import { useEffect, useMemo } from 'react'

import {
  selectAllServiceProducts,
  useGetBranchServiceProducts,
} from '@user/store/serviceProducts'
import { useAppSelector } from '@user/store/hooks'
import { selectAllLeadOppProducts } from '@user/store/leadOppProducts'

export function useServiceDuration(
  branchId: number,
  serviceIds: string[] = [],
) {
  const { loading, getServices } = useGetBranchServiceProducts()

  const entityServices = useAppSelector(selectAllLeadOppProducts)
  const branchServices = useAppSelector(selectAllServiceProducts)

  useEffect(() => {
    const branchLoaded = branchServices.some(
      (s) => s.branchId === `${branchId}`,
    )

    if (branchId !== -1 && !branchLoaded) getServices(`${branchId}`)
  }, [branchId, branchServices, getServices])

  const serviceDuration = useMemo(() => {
    if (!loading && branchServices.length > 0) {
      const selectedServices = entityServices
        .filter((s) => serviceIds.includes(`${s.id}`))
        .map((s) => s.externalId)

      return branchServices.reduce<number>((sum, svc) => {
        if (selectedServices.includes(svc.id)) return sum + svc.duration
        return sum
      }, 0)
    }
  }, [branchServices, entityServices, loading, serviceIds])

  return serviceDuration
}
